module.exports = __webpack_public_path__ + "img/germany.276052eb.png";